import { Col, Form, Select } from "antd";
import CustomDatePicker from "common/CustomDatePicker";
import { useEffect, useState } from "react";
import { SEWING_LINES } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";

const AuditReportFilter = () => {
  const [sewingList, setSewingList] = useState([]);
  const { Option } = Select;

  const getSewingList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      ...filterValues,
    };
    const response = await getData(SEWING_LINES, false, bodyData);

    if (response && response?.data?.code === 200) {
      setSewingList(response?.data?.data?.data || []);
    }
  };

  useEffect(() => {
    getSewingList();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Start Date" name="start_date">
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="End Date" name="end_date">
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Line" name="line_id">
          <Select
            showSearch
            placeholder="Select a Line"
            onSearch={(value) => {
              getSewingList({ name: value });
            }}
            optionFilterProp="children"
            size="small"
            filterOption={false}
            allowClear
            onClear={() => getSewingList()}
          >
            {isArrayAndHasValue(sewingList) &&
              sewingList.map((line) => (
                <Option value={line.id} key={line.id}>
                  {line.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default AuditReportFilter;
